import {Component, OnInit} from "@angular/core";
import {paramsHelper} from "../../helpers/params-helper";
import {DOCUMENT_TYPES} from "../../enums/enums";
import {BusService} from "../../services/bus.service";
import {JP} from "../../helpers/jp";
import {ILocaleItem} from "../../components/nv-locale/nv-locale.component";
import {IDocument} from "../../interfaces/document.definition";
import {localeUtils} from "../../helpers/locale-utils";

@Component({
  selector: 'app-text-page',
  templateUrl: './text-page.component.html',
  styles: []
})
export class TextPageComponent implements OnInit {
  pageParams = paramsHelper.page()
    .setDisabledOptionVisible(false)
    .setTitle("Тексты");

  collectionParams = paramsHelper.collection()
    .setObjectType(DOCUMENT_TYPES.TEXT)
    .setListLabels("Ключ", "%/id%")
    .setSearchParams(paramsHelper.search()
      .addStringParam("id"));

  document: IDocument;
  keys: string[];
  params = {newKey: void 0};


  constructor(private busService: BusService) {
  }


  getLocalesArray(): ILocaleItem[] {
    if (!this.document) {
      return [];
    }

    if (!JP.has(this.document, `/locales/${localeUtils.getLocale()}`))
    {
      JP.set(this.document, `/locales/${localeUtils.getLocale()}`, []);
    }
    return JP.get(this.document, `/locales/${localeUtils.getLocale()}`);
  }


  ngOnInit() {
    this.busService.onDocumentUpdated
      .subscribe(
        e => this.updateDocument(e.document));
  }


  onAddClick() {
    const newKey = this.params.newKey || "";
    if (newKey.length === 0) {
      return;
    }

    if (this.keys.indexOf(newKey) >= 0) {
      return;
    }

    this.addNewLocaleItem({key: newKey, value: []});
    this.params.newKey = "";
  }


  private addNewLocaleItem(item: ILocaleItem) {
    this.getLocalesArray().push(item);
    this.updateKeys();
  }


  private updateDocument(document: IDocument) {
    this.document = document;
    this.updateKeys();
  }


  private updateKeys() {
    this.keys = this.getLocalesArray().map(
      item => item.key);
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/text-page/text-page.component.ts